import IRegisterForm from '@/app/auth/register/IRegisterForm';
import ApiService from '@/app/common/service/ApiService';
import IRegisterApi from '@/app/auth/register/IRegisterApi';
import AuthFactory from '@/app/auth/register/AuthFactory';
import IRemindPasswordForm from '@/app/auth/remindPassword/IRemindPasswordForm';
import IResetPassword from '@/app/auth/resetPassword/IResetPassword';
import ILoginForm from '@/app/auth/login/ILoginForm';
import IUserInfo from '@/app/common/model/IUserInfo';
import StorageRepository from '@/app/common/repository/StorageRepository';
import CryptoService from '@/app/common/service/CryptoService';
import LoginStrategy from '@/app/common/service/LoginStrategy';

export default class AuthService {
  public static async registerUser(api: IRegisterForm): Promise<void> {
    return ApiService.post<IRegisterApi>(
      '/people/register/public',
      AuthFactory.toRegisterApi(api),
    );
  }

  static async remindPassword(api: IRemindPasswordForm): Promise<void> {
    return ApiService.post<IRemindPasswordForm>('auth/password', api);
  }

  static async resetPassword(api: IResetPassword, token: string) {
    const {password} = api;
    return ApiService.put('people/remind-password',
      {password: CryptoService.encode(password as string)},
      {
        headers: {
          Auth: `Bearer ${token}`,
        },
      });
  }

  static activateAccount(token: string) {
    return ApiService.put('people/activate-account/', null, {
      headers: {
        Auth: `Bearer ${token}`,
      },
    });
  }

  static async login(loginApi: ILoginForm): Promise<void> {
    const data = await this.signInUsingHashlog(loginApi);
    const hasher = {hasher: CryptoService.encode(data.hashedPassword + data.bearer)};
    const userInfo: IUserInfo = await ApiService.put('auth/signin', hasher, {
      headers: {
        Auth: `Bearer ${data.bearer}`,
      },
    });
    await LoginStrategy.resolveLoginStrategy(userInfo)
  }

  private static async signInUsingHashlog(loginApi: ILoginForm): Promise<{ bearer: string, hashedPassword: string }> {
    const {password, email} = {...loginApi};
    const hashedPassword = CryptoService.encode(password);
    const api = {
      hashlog: CryptoService.encode(hashedPassword + email.toLowerCase()),
    };
    return {bearer: await ApiService.post('auth/signin', api), hashedPassword};
  }

  static async logout() {
    await ApiService.delete('/auth/signout');
    StorageRepository.clearCredentials();
  }
}
